<template>
    <dm-scrollable-list :className="couponWrapperClass"
                        innerClassName="dml-coupon-tiles"
                        navClassName="dml-coupons__nav"
                        :itemsInViewport="itemsInViewport">
        <template slot="items">
            <li v-for="(coupon, index) in coupons"
                ref="coupons"
                class="dml-coupon-tile">
                <a :href="coupon.url"
                   data-ga="m_home.click_coupon"
                   :data-ga-label="coupon.alt">
                    <div v-if="coupon.isFreeDelivery" class="dml-coupon-tile__row dml-coupon-tile__row--header">
                        <span class="dml-coupon-tile__value dml-coupon-tile__value--delivery">Darmowa dostawa</span>
                        <dm-icon class="dml-coupon-tile__backdrop dml-coupon-tile__backdrop--delivery" name="truck" :width="122" :height="122" />
                    </div>
                    <div v-else class="dml-coupon-tile__row dml-coupon-tile__row--header">
                        <span class="dml-coupon-tile__value">Rabat {{coupon.couponValue}}</span>
                        <dm-icon class="dml-coupon-tile__backdrop" name="percent" :width="144" :height="114" />
                    </div>
                    <div class="dml-coupon-tile__row">
                        <div class="dml-coupon-tile__column dml-coupon-tile__column--left">
                            <div class="dml-coupon-tile__image-wrapper">
                                <img :data-src="coupon.shopLogoUrl"
                                     src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                     class="dml-coupon-tile__image lazy"
                                     :alt="coupon.alt" />
                            </div>
                        </div>
                        <div class="dml-coupon-tile__column dml-coupon-tile__column--right">
                            <dm-icon class="_smhr" name="clock" :width="16" :height="16" />
                            <span class="dml-coupon-tile__duration">{{coupon.duration}}</span>
                        </div>
                        </div>
                    <div class="dml-coupon-tile__row _splb">
                        <div class="dml-coupon-tile__column dml-coupon-tile__column--left">
                            <span class="dml-coupon-tile__discount-info">{{coupon.productDiscountTypeInfo}}</span>
                        </div>
                        <div class="dml-coupon-tile__column dml-coupon-tile__column--right">
                            <div class="dml-coupon-tile__link">
                                <span>Sprawdź</span>
                            </div>
                        </div>
                    </div>
                </a>
            </li>
        </template>
    </dm-scrollable-list>
</template>
<script>
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-coupon-carousel',
        components: {
            'dm-scrollable-list': ScrollableListComponent,
            'dm-icon': IconComponent
        },
        props: {
            coupons: {
                type: Array,
                required: true
            },
            itemsInViewport: {
                type: Number,
                default: 5
            },
            place: {
                type: String,
                required: false
            }
        },
        computed: {
            couponWrapperClass() {
                return this.place ? `dml-coupons dml-coupons--${this.place}` : 'dml-coupons__tiles';
            },
        }
    };
</script>
